<template>
    <div :class="$style.wrapper">
        <div :class="$style.left">
            <!--<div :class="$style.radio">-->
                <!--<span>下单时间</span>-->
                <!--<el-radio-group v-model="currId">-->
                    <!--<el-radio v-for="{id, name} in list" :key="id" :label="id">{{name}}</el-radio>-->
                <!--</el-radio-group>-->
            <!--</div>-->
            <div :class="$style.date">
                <span>下单时间</span>
                <el-date-picker
                    size="small"
                    v-model="date"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-value="new Date()">
                </el-date-picker>
                <el-button size="small" @click="handleClick">筛选</el-button>
            </div>
        </div>

        <div :class="$style.search">
            <el-select v-model="searchType" placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-input
                @keyup.enter.native="chose"
                :vip="vip"
                v-model="vip"
                :placeholder="请输入"
                clearable>
            </el-input>
            <el-button @click="chose()">订单搜索</el-button>
        </div>
    </div>
</template>

<script>
    const list = [{
        id: 7,
        name: '7天内',
    }, {
        id: 30,
        name: '30天内',
    }, {
        id: 90,
        name: '90天内',
    }];
    export default {
        props: ['currDate', 'dateRange', 'handleClick', 'vip'],
        data () {
            return {
                list: list,
                currId: '',
                date: null,
                vip: '',
                searchType: 'contract_number',
                 options: [{
                     value: 'contract_number',
                     label: '合同订单号'
                 }, {
                  value: 'vip',
                  label: 'VIP卡号'
                }, {
                  value: 'product',
                  label: '商品'
                }, {
                     value: 'mendian',
                     label: '门店'
                 }, {
                  value: 'order',
                  label: '订单'
                }, {
                     value: 'mobile',
                     label: '客户电话'
                 }, {
                     value: 'payname',
                     label: '支付方式'
                 }
                ],
            };
        },
        methods:{
            //根据vip搜索订单
            chose(){
                console.log(this.vip,this.searchType);
                this.$emit('update:vip',this.vip);
                 this.$emit('update:searchType',this.searchType);
                this.handleClick();
            }
        },
        watch: {
            currId (val) {
                this.$emit('update:currDate', val);

                if (val !== '') {
                    this.date = null;
                    this.handleClick();
                }
            },
            date (val) {
                this.$emit('update:dateRange', val);
                if (val) {
                    this.currId = '';
                }
            }
        }
    };
</script>

<style lang="less" module>
    .wrapper {
        display: flex;
        /*justify-content: space-between;*/
        align-items: center;
        .left {
            display: flex;
            align-items: center;
            padding: 20px;
            font-size: 14px;
            .radio {
                margin-right: 40px;
                label {
                    margin-left: 20px;
                }
            }
            .date {
                :global(.el-date-editor) {
                    width: 250Px;
                    margin-left: 10px;
                    border-radius: 0;
                    :global(.el-range-input) {
                        width: 35%;
                    }
                }
                & > button {
                    background: #e6e6e6;
                    border-radius: 2px;
                    width: 52Px;
                    height: 32Px;
                    font-size: 14px;
                    color: #ffffff;
                    padding: 0;
                    border: 0;
                }
            }
        }
        .search {
            display: flex;
            margin-left: 30px;
            input {
                width: 300px;
                border-radius: 0;
                border: 1px solid #d8dde6;
                border-right: 0;
            }
            button {
                border-radius: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Common/DateFilter.vue